import React from 'react';
import { POSSIBLE_FILTERS_ENTITIES } from 'hooks/useMemorizeInputsFilters';
import { entitiesName } from 'views/CRM/shared/utils/entitiesName';
import { useEntityCustomFieldsByRecordType } from 'views/fieldConfigs/hooks/useCustomFieldsByRecordType';
import ImportDataForm from 'components/ImportData';
import AccountService from '../../../services/accountService';
import { defaultImportFields } from 'components/ImportData/data/fields';

/**
 * Componente ImportAccountsModal para gerenciar a importação de dados de contas.
 *
 * @component
 * @param {Object} props - Propriedades do componente
 * @param {boolean} props.isOpen - Controla se o modal está visível
 * @param {Function} props.setIsOpen - Função para alternar a visibilidade do modal
 * @param {string|number} props.recordTypeId - ID do tipo de registro para o qual as contas estão sendo importadas
 *
 * @returns {JSX.Element} A interface do modal de importação de contas
 */

const ImportAccountsModal = ({ isOpen, setIsOpen, recordTypeId }) => {
  const { getCustomFields } = useEntityCustomFieldsByRecordType(
    entitiesName.ACCOUNT,
    recordTypeId
  );

  return (
    <ImportDataForm
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      recordTypeId={recordTypeId}
      importService={AccountService.importAccounts}
      validateImportService={AccountService.validateImportAccounts}
      defaultFields={defaultImportFields.CRM_ACCOUNT}
      filterEntity={POSSIBLE_FILTERS_ENTITIES.CRM_ACCOUNT_IMPORT}
      getCustomFields={getCustomFields}
      type="accountEntities"
    />
  );
};

export default ImportAccountsModal;
